// Where a score's colour comes from, for every screen that prints one.
import type { Band } from "@/lib/dashboard/scale";

/**
 * Four muted steps from best to worst in the column. Kept beside the components rather
 * than inside the pure scale module, which knows about bands but nothing about Tailwind.
 */
export const BAND_TONE: Record<Band, string> = {
  top: "text-score-top",
  high: "text-score-high",
  mid: "text-score-mid",
  low: "text-score-low",
  none: "text-fg-faint",
};
